<div id="cumulativeResultsForm" fxLayout="column" fxLayoutAlign="start center">
  <dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
  </dx-load-panel>

  <div class='content-block dx-card responsive-paddings ocl-top-container' style='width: 95vw;'>
    <div fxLayout='row' fxLayoutAlign='stretch' class='padding-block'>
      <h3>Cumulative Results</h3>
    </div>
      <div class="padding-block" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start"
           fxLayoutAlign="space-between start"
           [ngStyle.lt-md]="{height: 'auto'}">
        <div class="dx-card" fxLayout="column" style="width: 100%; padding: 8px; margin: 6px;">
          <div fxLayout="column" fxFlex="49%"
               style="padding: 10px;margin-top: 8px; margin-bottom: 8px;">
            <h5 style="margin-bottom: 8px!important;margin-top: 8px!important;">Patient Information</h5>
            <address class="details">
              <span class="strong">Patient:</span> {{ PatientFullName }} {{ DOB }} {{ Gender }}<br/>
              <span class="strong">Address:</span> {{ PatientAddress }}<br/>
              <span class="strong">Phone:</span> {{ orderInfo ? orderInfo.patientPhone : '' }}<br/>
            </address>
          </div>
        </div>

        <div class="dx-card" fxLayout="column" style="width: 100%; padding: 8px; margin: 6px;">
          <div fxLayout="column" fxFlex="49%"
               style="padding: 10px; height: inherit; margin-top: 8px; margin-bottom: 8px;">
            <h5 style="margin-bottom: 8px!important;margin-top: 8px!important;">Settings</h5>
            <div fxLayout="column" fxLayoutAlign="space-between">
              <div fxLayout="row">
                <div fxFlex="80%" fxFlex.xs="100%">
                  <app-client-selector
                    [control]="clientSelector"
                    [orderId]="orderInfo ? orderInfo.id : 0"
                    [startDate]="start"
                    [endDate]="end"
                    [limit]="records"
                    [filterClients]="filterClients"
                    [required]="false" style="width: 100% !important;">
                  </app-client-selector>
                </div>
              </div>
              <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign.xs="start" fxLayoutAlign="space-between">
                <div fxFlex.gt-xs="80%">
                  <app-from-to-date-range-selector
                    [startGroupControl]="startDateControl"
                    [endGroupControl]="endDateControl"
                  ></app-from-to-date-range-selector>
                </div>
                <div class="dx-field" style="margin-left: 8px; width: 100% !important;" fxFlex.gt-xs="16%">
                  <div class="dx-field-label" style="width: 100% !important;">Records</div>
                  <div class="dx-field-value" style="width: 100% !important;">
                    <dx-number-box
                      [value]="5"
                      [min]="0"
                      (onValueChanged)="recordsValueChanged($event)"
                      [showSpinButtons]="true"
                    ></dx-number-box>
                  </div>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center">
              <dx-load-indicator class='button-indicator' [height]="24" style="margin-right: 8px"
                                 [visible]="toxicologyResultsLoading || clinicalResultsLoading || microbiologyResultsLoading">
              </dx-load-indicator>
              <dx-button text="Search" (click)="search()">
              </dx-button>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="content-block dx-card responsive-paddings ocl-bottom-container"
       style="width: 95vw !important; padding-right: 0 !important; padding-left: 0 !important;">
    <div fxLayout="col" fxLayoutAlign="start">
      <div class="ocl-container-with-padding" style="width: 100%;">
        <dx-tab-panel
          [dataSource]="[
                            { id: 1, title: 'Clinical Results', template: 'clinicalResults', visible: clinicalResultsVisible },
                            { id: 2, title: 'Microbiology Results', template: 'microbiologyResults', visible: microbiologyResultsVisible },
                            { id: 3, title: 'Toxicology Results', template: 'toxicologyResults', visible: toxicologyResultsVisible }
                        ]"
          [selectedIndex]="selectedTab"
          [loop]="false"
          [animationEnabled]="true"
          [swipeEnabled]="false"
          style="width: 100%"
        >
          <div *dxTemplate="let results of 'clinicalResults'" style="height: 100%; overflow: hidden">
            <div *ngIf="clinicalResultsVisible" style="height: 100%; overflow: hidden">
              <div *ngIf="clinicalGraph.length > 0 || clinicalSeriesGraph.length > 0">
                <dx-chart
                  style="width: 100% !important; padding-left: 16px !important; padding-right: 16px !important;"
                  palette="Blue"
                  [series]="clinicalSeriesGraph"
                  [dataSource]="clinicalGraph"
                  zoomingMode="all"
                  [adjustOnZoom]="true"
                  (onZoomEnd)="onZoomEnd($event)">
                  <dxo-common-series-settings type="line" argumentField="collectionDate">
                  </dxo-common-series-settings>
                  <dxo-argument-axis>
                    <dxo-label [visible]="true" [customizeText]="customizeText"></dxo-label>
                  </dxo-argument-axis>
                  <dxo-zoom-and-pan
                    argumentAxis="both"
                    [allowTouchGestures]="true"
                    [allowMouseWheel]="true"

                  ></dxo-zoom-and-pan>
                  <dxo-scroll-bar [visible]="visibleScroll"></dxo-scroll-bar>
                  <dxo-margin [bottom]="20"></dxo-margin>
                  <dxo-argument-axis
                    [valueMarginsEnabled]="false"
                    discreteAxisDivisionMode="crossLabels">
                    <dxo-grid [visible]="true"></dxo-grid>
                  </dxo-argument-axis>
                  <dxo-legend
                    verticalAlignment="bottom"
                    horizontalAlignment="center"
                    itemTextPosition="bottom">
                  </dxo-legend>
                  <dxo-export [enabled]="true"></dxo-export>
                  <dxo-tooltip
                    [enabled]="true"
                    contentTemplate="content">
                  </dxo-tooltip>
                  <div *dxTemplate="let info of 'content'" class='state-tooltip'>
                    <p [innerHTML]="graphTooltip(info)"></p>
                  </div>
                </dx-chart>
              </div>
              <dx-data-grid
                [dataSource]="clinicalRows"
                [showRowLines]="true"
                [showBorders]="true"
                [highlightChanges]="true"
                [allowColumnReordering]="false"
                [hoverStateEnabled]="true"
                (onSelectionChanged)="clinicalSelection($event)"
                height="100%"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [showBorders]="true"
                [wordWrapEnabled]="true"
                [columns]="clinicalResultsColumns"
                (onRowPrepared)="clinicalRow($event)"
                (onContentReady)="onContentReady($event)"
              >
                <dxo-scrolling mode="infinite"></dxo-scrolling>
                <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
              </dx-data-grid>
            </div>
          </div>
          <div *dxTemplate="let results of 'toxicologyResults'" style="height: 100%; overflow: hidden">
            <div *ngIf="toxicologyResultsVisible" style="height: 100%; overflow: hidden">
              <dx-data-grid
                [dataSource]="toxicologyRows"
                [showRowLines]="true"
                [showBorders]="true"
                [highlightChanges]="true"
                [allowColumnReordering]="false"
                [hoverStateEnabled]="true"
                height="100%"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                [columns]="toxicologyResultsColumns"
                (onRowPrepared)="toxicologyRow($event)"
                (onContentReady)="onContentReady($event)"
              >
                <!--<dxo-scrolling columnRenderingMode="infinite"></dxo-scrolling>-->
                <dxo-scrolling mode="infinite"></dxo-scrolling>
              </dx-data-grid>
            </div>
          </div>
          <div *dxTemplate="let results of 'microbiologyResults'" style="height: 100%; overflow: hidden">
            <div *ngIf="microbiologyResultsVisible" style="height: 100%; overflow: hidden">
              <dx-data-grid
                [dataSource]="microbiologyRows"
                [showRowLines]="true"
                [highlightChanges]="true"
                [allowColumnReordering]="false"
                [hoverStateEnabled]="true"
                height="100%"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [showBorders]="true"
                [wordWrapEnabled]="true"
                [columns]="microbiologyResultsColumns"
                (onRowPrepared)="microbiologyRow($event)"
                (onContentReady)="onContentReady($event)"
              >
                <!--<dxo-scrolling columnRenderingMode="infinite"></dxo-scrolling>-->
                <dxo-scrolling mode="infinite"></dxo-scrolling>
              </dx-data-grid>
            </div>
          </div>
        </dx-tab-panel>
      </div>
    </div>
  </div>
</div>
